import React, { useEffect, useState } from "react";
import { FiCheckCircle } from "react-icons/fi";
import { LiaTimesSolid } from "react-icons/lia";
import styled from "styled-components";

interface ModalProps {
  open: boolean;
  toggle?: () => void;
  header?: string;
  children: React.ReactNode;
  width?: string;
  noPadding?: boolean
  noHeaderJustChildren?: boolean
}

const SideModalV2 = ({
  open,
  toggle,
  header,
  width,
  children,
  noPadding,
  noHeaderJustChildren
}: ModalProps) => {
  const [openx, setOPenx] = useState(false);
  useEffect(() => {
    setOPenx(open);
  }, [open]);

  return (
    <Container width={width} className={`!z-50 no-scrollbar ${open && "show"}`}>
      <div className="no-scrollbar main-content pb-[50px]">
        {noHeaderJustChildren
          ? children
          : <>
            <div className="header">
              <h5>
                {header}
              </h5>
              {!toggle
                ? null
                : <LiaTimesSolid onClick={() => {
                  if (!toggle) return
                  toggle()
                }} className="close" />}
            </div>

            <div className={`no-scrollbar children ${noPadding ? "" : "p-[25px]"}`}>
              {children}
            </div>
          </>}
      </div>
    </Container>
  );
};

interface ConatinerProps {
  width?: string
}

const Container = styled.div<ConatinerProps>`
    position: fixed;
    visibility: hidden;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    opacity: 0;
    transition: all .2s ease-in-out;
    transition-delay: .1s;
    margin-top: 0px !important;

    &.show{
      opacity: 1;
      visibility: visible;

      .main-content{
        width: ${props => props?.width ? props.width : "50vw"};
        
        @media (max-width: 768px) {
            width: 100% !important;
            padding: 0;
        }
      }
    }

    .main-content::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
    }

    .main-content{
        position: relative;
        transition: all .5s ease;
        transition-delay: .3s;
        width: 0;
        height: 100%;
        background-color: white;
        margin-left: auto;
        overflow-y: scroll;
        z-index: 10;

        .header{
          padding: 35px 25px 20px 25px !important;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #CCCCCC80;

          h5{
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            text-align: left;
            color: #000000;
            margin-bottom: 0 !important;
            text-transform: uppercase;
          }

          .close{
            font-size: 22px;
            cursor: pointer;
          }
        }

        .children{
          label{
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            text-align: left;
            color: #0B0B0BCC;
          }
        }
    }
`

export const SideModalFormHeader = styled.h6`
    background: #FBFAFA;
    padding: 15px 25px;
    font-family: Geist;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #232324;
    z-index: 10;
`

export const InfoPill: React.FC<{ text: string, type?: "SUCCESS" }> = ({ text, type }) => {
  return <div className={`${type === "SUCCESS" ? "bg-[#EEFCF8]" : "bg-[#FBF4F4]"} px-5 py-3 rounded-[12px] flex items-center`}>
    {type === "SUCCESS" && <FiCheckCircle className="text-[#246453] text-xl mr-2" />}
    <p className={`text-[12px] font-[400] ${type === "SUCCESS" ? "text-[#246453]" : "text-textGrey/80"}`}>{text}</p>
  </div>
}

export default SideModalV2;
